<template>
	<div class="u-wrap">
		<div class="card">
			<van-form>
				<van-cell :title="model.address">
					<van-icon name="location" color="#1777FF" slot="icon" style="margin-top: 5px; margin-right: 5px" />
				</van-cell>
				<van-field :required="true" v-model="model.lxdh" label="联系电话" placeholder="请输入联系电话"
					input-align="right" />
				<van-field :required="true" v-model="model.xjcrs" label="需检测人数" placeholder="请输入需检测人数"
					input-align="right" />
				<u-select dictCode="yqfk_jkzk" :required="true" readonly clickable v-model="model.jkzk" label="健康状况"
					input-align="right" placeholder="请选择健康状况" right-icon="arrow-down"></u-select>
				<u-select dictCode="yes_or_no" :required="true" readonly clickable v-model="model.sfgl" label="是否隔离"
					input-align="right" placeholder="请选择是否隔离" right-icon="arrow-down"></u-select>
				<van-field :required="true" v-model="model.xxdz" label="详细地址" placeholder="请输入详细地址"
					input-align="right" />
				<van-cell :required="true" title="上门原因" value="" :border="false" />
				<textarea placeholder="请输入上门原因" class="xxnr" v-model="model.smyy"></textarea>
				<div class="tips">
				</div>
			</van-form>
		</div>
		<div class="b-btn">
			<button class="b-button" :disabled="disable" @click="clickSumbit">提交</button>
		</div>

		 <smrz-pop :show="showSmrz"></smrz-pop>
	</div>
</template>

<script>
	import Vue from 'vue'
	import {
		WX_USER
	} from "@/store/mutation-types"
	import {
		getAction,
		postAction
	} from '@/api/manage'
	import qzzxCard from '@/views/common/qzzx-card.vue'
	import uSelect from '@/components/page/u-select.vue'
	import FileMixin from '@/views/common/mixins/file-mixin.js'
	import OpenIdMixin from "@/views/common/mixins/openId-mixin.js";
	import smrzPop from '@/views/common/smrz-pop.vue'
	import {
		isMobile
	} from '@/utils/validate'
	import wx from 'weixin-js-sdk'
	import {
		ImagePreview
	} from 'vant'

	export default {
		mixins: [FileMixin,OpenIdMixin], // 使用mixin (在main.js注册全局组件)
		components: {
			qzzxCard,
			uSelect,
			smrzPop,
		},
		setup() {
			// themeVars 内的值会被转换成对应 CSS 变量
			// 比如 sliderBarHeight 会转换成 `--van-slider-bar-height`
			const themeVars = {
				cellRightIconColor: '#f00',
			}

			return {
				themeVars,
			}
		},
		data() {
			return {
				url: '/yqfk/smhs/add',
				model: {
					address: '',
					lat: '',
					lng: '',
					lxdh: '',
					xjcrs: '',
					jkzk: '',
					sfgl:'',
					smyy:''
				},
				// 抽屉参数
				popupLayerClass: '',
				// more参数
				hideMore: true,

				isVoice: true,
				voiceTis: '按住 说话',
				recordTis: '手指上滑 取消发送',
				recording: false,
				willStop: false,
				initPoint: {
					identifier: 0,
					Y: 0,
				},
				recordTimer: null,
				recordLength: 0,
				voiceList: [],
				showSmrz:false,

			}
		},
		created() {
			

			  this.initOpenId().then(res=>{
				if(this.isSmrz()){
					let object = Vue.ls.get(WX_USER, {});
					this.model.lxdh = object.phone
					this.initWxInfo();
					this.getAddress();
				}else{//弹出实名认证
					this.showSmrz = true;
				}
				}).catch(err=>{

				});
		},
		computed: {
			disable() {
				let disable = true
				if (this.model.lxdh && this.model.xjcrs && this.model.jkzk && this.model.sfgl && this.model.smyy && this.model.xxdz) {
					disable = false
				}
				return disable
			},
		},
		methods: {
			//调用接口
			initWxInfo() {
				let urlHref = encodeURIComponent(window.location.href)
				let params = {
					url: urlHref
				}
				let url = `/sys/mlogin/get/jsdk?url=${urlHref}`
				postAction(url, params).then((res) => {
					if (res.success) {
						let obj = res.result
						wx.config({
							debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
							appId: obj.appId, // 必填，公众号的唯一标识
							timestamp: obj.timestamp, // 必填，生成签名的时间戳
							nonceStr: obj.nonceStr, // 必填，生成签名的随机串
							signature: obj.signature, // 必填，签名，见附录1
							jsApiList: [
								'getLocation',
								'startRecord',
								'stopRecord',
								'onVoiceRecordEnd',
								'playVoice',
								'onVoicePlayEnd',
								'pauseVoice',
								'stopVoice',
								'uploadVoice',
								'downloadVoice',
							],
						})
					}
				})
			},
			getAddress() {
				let _this = this;
				wx.ready(() => {
					// config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，
					wx.getLocation({
						type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
						success: (d) => {
							var latitude = d.latitude // 纬度，浮点数，范围为90 ~ -90
							var longitude = d.longitude // 经度，浮点数，范围为180 ~ -180。
							_this.model.lng = longitude
							_this.model.lat = latitude
							console.log("地址",latitude + '==' + longitude)
							var latLng = new qq.maps.LatLng(d.latitude, d.longitude);
							getAddr.getAddress(latLng)
						},
						fail: (d) => {
							console.log("地址",d)
							this.$toast('获取微信坐标位置失败，请点击右上角‘…’→刷新一下，谢谢配合！')
						},
					})
				})
				wx.error((err) => {
					console.log(error)
				})

				var getAddr = new qq.maps.Geocoder({
					complete: function(res) {
						// _this.address = res.detail
						// var allAddress = res.detail.addressComponents
						var address = res.detail.address;
						_this.model.address = address;
					}
				})
			},
			change(index) {
				this.currentTab = index
			},
			deleteVoice(index) {
				this.voiceList.splice(index, 1);
				this.audioPathList.splice(index, 1);
			},
			showMore() {
				if (this.hideMore) {
					this.hideMore = false
					this.openDrawer()
				} else {
					this.hideDrawer()
				}
			},
			openDrawer() {
				this.popupLayerClass = 'showLayer'
			},
			hideDrawer() {
				this.popupLayerClass = ''
				setTimeout(() => {
					this.hideMore = true
				}, 150)
			},
			clickSumbit() {
				if (!isMobile(this.model.lxdh)) {
					this.$toast('请输入正确手机号码');
					return;
				}
				this.model.openId = this.$store.getters.openId
				console.log("model",this.model);
				postAction(this.url, this.model).then((res) => {
					if (res.success) {
						this.$router.replace({
							name: 'success',
						})
					} else {
						this.$toast(res.message)
					}
				})
			},
			preImage(index, imgList) {
				ImagePreview({
					images: imgList,
					startPosition: index,
				})
			},
		},
		beforeDestroy() {
			this.dispatchVideo();
		},
	}
</script>

<style lang="less" scoped>
	@import '../../assets/less/dialog.less';

	.u-wrap {
		min-height: 100vh;
		box-sizing: border-box;
		background-color: #f5f5f5;
		padding-bottom: 70px;
		padding-top: 2px;
	}

	.heard {
		position: fixed;
		top: 0px;
		left: 0px;
		width: 100%;
		z-index: 1;
	}

	.u-content-wrap {
		flex: 1;
		display: flex;
	}

	.card {
		background: #ffffff;
		padding: 0px;
		margin: 12px 8px 0px;
		box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.04);
		border-radius: 5px;
		overflow: hidden;
		height: auto;
		margin-bottom: 20px;
	}

	.xxnr {
		width: 90%;
		margin: 0 12px;
		height: 128px;
		border-radius: 5px;
		border: 1px solid #ededed;
		padding: 8px;
		font-size: 14px;
	}

	.tips {
		padding: 12px;
		color: #999999;
		line-height: 18px;
		font-size: 12px;
		display: flex;
	}

	.tip {
		flex: 1;
		margin-left: 6px;
	}

	.sjcl-bottom {
		height: 60px;
		width: 96%;
		background: #ffffff;
		position: fixed;
		bottom: 0px;
		padding: 0px 10px;
		align-items: center;
		justify-content: center;
		display: flex;
		box-shadow: 0px -3px 8px 0px rgba(216, 216, 216, 0.5);

		.voice-mode {
			flex: 1;
			margin-left: 10px;
			height: 40px;
			font-size: 16px;
			background: rgba(255, 255, 255, 1);
			border: 1px solid rgba(211, 211, 211, 1);
			border-radius: 5px;
			text-align: center;
			line-height: 40px;
		}
	}

	.b-btn {
		padding: 0 20px;

		.b-button {
			width: 100%;
			height: 44px;
			background: #3f8ffb;
			border-radius: 5px;
			opacity: 1;
			border: none;
			color: #ffffff;
		}

		.b-button[disabled] {
			opacity: 0.48;
		}
	}

	.imgList .title {
		font-size: 15px;
		font-weight: 600;
		color: #333;
		padding-left: 12px;
	}


	.pre-box {
		display: flex;
		align-items: center;
		/* justify-content: space-between; */
		flex-wrap: wrap;
		padding: 12px;
	}

	.pre-item {
		/* flex: 0 0 48.5%; */
		border-radius: 5px;
		height: 80px;
		overflow: hidden;
		position: relative;
		/* margin-bottom: px; */
	}

	.u-progress {
		position: absolute;
		bottom: 5px;
		left: 4px;
		right: 4px;
		z-index: 9;
		width: auto;
	}

	.pre-item-image {
		width: 80px;
		height: 80px;
		border-radius: 4px;
		margin-right: 10px;
		margin-bottom: 8px;
		object-fit: cover;
	}

	.u-delete-icon {
		position: absolute;
		top: 0px;
		right: 0px;
		z-index: 10;
		/* background-color: $u-type-error; */
		border-radius: 50px;
		width: 22px;
		height: 22px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.input {
		width: 80px;
		height: 80px;
		position: absolute;
		display: none;
	}

	.imgList .title {
		font-size: 15px;
		font-weight: 600;
		color: #333;
		padding-left: 12px;
	}

	.pre-box {
		display: flex;
		align-items: center;
		/* justify-content: space-between; */
		flex-wrap: wrap;
		padding: 12px;
	}

	.pre-item {
		/* flex: 0 0 48.5%; */
		border-radius: 5px;
		height: 80px;
		overflow: hidden;
		position: relative;
		/* margin-bottom: px; */
	}

	.u-progress {
		position: absolute;
		bottom: 5px;
		left: 4px;
		right: 4px;
		z-index: 9;
		width: auto;
	}

	.pre-item-image {
		width: 80px;
		height: 80px;
		border-radius: 4px;
		margin-right: 10px;
		margin-bottom: 8px;
	}

	.u-delete-icon {
		position: absolute;
		top: 0px;
		right: 0px;
		z-index: 10;
		/* background-color: $u-type-error; */
		border-radius: 50px;
		width: 22px;
		height: 22px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.video-p {
		padding: 12px;
	}

	.video-class {
		margin-right: 10px;
		margin-bottom: 10px;
	}

	.title {
		line-height: 30px;
	}


	.cssSelect {
		//这里为css选择器
		-webkit-touch-callout: none;
		/*系统默认菜单被禁用*/
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		/*用户是否能够选中文本*/
	}

	.yuyin {
		width: 100px;
		height: 35px;
		background: #367EFF;
		border: 1px solid rgba(211, 211, 211, 1);
		border-radius: 35px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		padding-left: 10px;
	}

	.audio {
		display: flex;
		align-items: center;
		margin-bottom: 10px;

	}

	.icon_audio_default {
		background: transparent url('~@images/iconloop.png') no-repeat 0 0;
		width: 14px;
		height: 18px;
		vertical-align: middle;
		display: inline-block;
		-webkit-background-size: 42px 18px;
		background-size: 42px 18px;
		background-position: -28px center;
	}

	.icon_audio_playing {
		background: transparent url('~@images/iconloop.png') no-repeat 0 0;
		width: 14px;
		height: 18px;
		vertical-align: middle;
		display: inline-block;
		-webkit-background-size: 42px 18px;
		background-size: 42px 18px;
		-webkit-animation: audio_playing 1s infinite;
		background-position: 0px center;
	}


	@-webkit-keyframes audio_playing {
		30% {
			background-position: 0px center;
		}

		31% {
			background-position: -14px center;
		}

		61% {
			background-position: -14px center;
		}

		61.5% {
			background-position: -28px center;
		}

		100% {
			background-position: -28px center;
		}
	}

	.voice-list {
		padding-left: 12px;
		padding-bottom: 12px;
	}
</style>
